export interface Device {
  id: string;
  vaultName: string;
  device_Type: string;
  selected_Device_Sub_Type: string;
  device_Physical_Location: string;
  reader_IP: string;
  port_Number: number;
  device_Status: string;
  isDeleted: boolean;
  isActive: boolean;
}
export const DeviceInitialState = {
  id: '',
  vaultName: '',
  device_Type: '',
  selected_Device_Sub_Type: '',
  device_Physical_Location: '',
  reader_IP: '',
  port_Number: 0,
  device_Status: '',
  isDeleted: false,
  isActive: false,
};
